// extracted by mini-css-extract-plugin
module.exports = {"bookBanner":"style_bookBanner__viSUS","banner":"style_banner__2B7Wn","inner":"style_inner__5enbg","content":"style_content__35Vk4"};